module.exports = __webpack_public_path__ + "catalog/holes/door/texture.jpg";